import { render } from "./Datatable.vue?vue&type=template&id=282283e0&scoped=true"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=282283e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282283e0"],['__file',"src/components/mdbvue/pro/Tables/Datatable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "282283e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('282283e0', __exports__)) {
    api.reload('282283e0', __exports__)
  }
  
  module.hot.accept("./Datatable.vue?vue&type=template&id=282283e0&scoped=true", () => {
    api.rerender('282283e0', render)
  })

}


export default __exports__